import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ContactEmploymentDetailType } from '@/modules/contact/enums/ContactEmploymentDetailType';

export class ContactEmploymentDetail extends BaseEntityModel {
  id?: number;
  contactId?: number;
  wasEmployed?: boolean;
  wasUnemployed?: boolean;
  wasRetired?: boolean;
  wasSelfEmployed?: boolean;
  wasMilitaryMember?: boolean;
  wasMilitaryVeteran?: boolean;
  militaryServiceStatus?: string;
  wasFederalEmployee?: boolean;
  diedOnActiveMilitaryDuty?: boolean;
  diedOnInactiveMilitaryDuty?: boolean;
  diedFromMilitaryServiceRelatedInjury?: boolean;
  diedReceivingVeteranAffairsCare?: boolean;
  diedReceivingVeteranAffairsCompensation?: boolean;
  diedWhilePublicSafetyOfficerOnDuty?: boolean;
  diedReceivingFersRetirement?: boolean;
  diedEntitledToReceiveFersRetirement?: boolean;
  diedMemberOfNativeBand?: boolean;
  wasCoalIndustryWorker?: boolean;
  diedFromPneumoconiosis?: boolean;
  diedReceivingEmploymentInsurance?: boolean;
  diedEligibleForButNotReceivingEmploymentInsurance?: boolean;
  diedReceivingProvincialIncomeAssistance?: boolean;
  diedReceivingWorkersCompensation?: boolean;

  constructor(model: Partial<ContactEmploymentDetail> = {}) {
    super(model);

    this.id = model.id;
    this.contactId = model.contactId;
    this.wasEmployed = model.wasEmployed;
    this.wasUnemployed = model.wasUnemployed;
    this.wasRetired = model.wasRetired;
    this.wasSelfEmployed = model.wasSelfEmployed;
    this.wasMilitaryMember = model.wasMilitaryMember;
    this.wasMilitaryVeteran = model.wasMilitaryVeteran;
    this.militaryServiceStatus = model.militaryServiceStatus;
    this.wasFederalEmployee = model.wasFederalEmployee;
    this.diedOnActiveMilitaryDuty = model.diedOnActiveMilitaryDuty;
    this.diedOnInactiveMilitaryDuty = model.diedOnInactiveMilitaryDuty;
    this.diedFromMilitaryServiceRelatedInjury = model.diedFromMilitaryServiceRelatedInjury;
    this.diedReceivingVeteranAffairsCare = model.diedReceivingVeteranAffairsCare;
    this.diedReceivingVeteranAffairsCompensation = model.diedReceivingVeteranAffairsCompensation;
    this.diedWhilePublicSafetyOfficerOnDuty = model.diedWhilePublicSafetyOfficerOnDuty;
    this.wasCoalIndustryWorker = model.wasCoalIndustryWorker;
    this.diedFromPneumoconiosis = model.diedFromPneumoconiosis;
    this.diedReceivingEmploymentInsurance = model.diedReceivingEmploymentInsurance;
    this.diedEligibleForButNotReceivingEmploymentInsurance =
      model.diedEligibleForButNotReceivingEmploymentInsurance;
    this.diedReceivingProvincialIncomeAssistance = model.diedReceivingProvincialIncomeAssistance;
    this.diedReceivingWorkersCompensation = model.diedReceivingWorkersCompensation;
    this.diedReceivingFersRetirement = model.diedReceivingFersRetirement;
    this.diedEntitledToReceiveFersRetirement = model.diedEntitledToReceiveFersRetirement;
    this.diedMemberOfNativeBand = model.diedMemberOfNativeBand;
  }

  get availableContactEmploymentDetailTypeKeys(): string[] {
    return ContactEmploymentDetailType.getValues<ContactEmploymentDetailType>()
      .filter(({ key }: ContactEmploymentDetailType): boolean => !!this[key])
      .map(({ key }: ContactEmploymentDetailType): string => key);
  }
}
